// Production deploy: 2026-09-15c (forced password creation)
import './polyfills'; // Must be first — URL.parse polyfill for Safari <18
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';
import { loadGoogleMapsScript } from './components/shared/AddressAutocomplete';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Load Google Maps for address autocomplete (non-blocking)
const googlePlacesKey =
  (window as any).ENV?.GOOGLE_PLACES_API_KEY ||
  import.meta.env.VITE_GOOGLE_PLACES_API_KEY;

if (googlePlacesKey) {
  loadGoogleMapsScript(googlePlacesKey).catch((err) =>
    console.warn('Google Maps failed to load, address autocomplete unavailable:', err)
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
